import { render, staticRenderFns } from "./vip.vue?vue&type=template&id=de056900"
var script = {}
import style0 from "./vip.vue?vue&type=style&index=0&id=de056900&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports